import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const initialAdminContact = {
  contactId: null,
  firstName: null,
  lastName: null,
  salutation: null,
  companyId: null,
  companyName: null,
  categoryId: null,
  categoryName: null,
  createdUserId: null,
  createdUserName: null,
  createdDate: null,
  duoFlag: null,
  email: null,
  lastLoginDate: null,
  lastUpdateDate: null,
  statusUpdateDate: null,
  statusId: null,
  webStatusName: null,
  webUserId: null,
  webUserName: null,
  webStatusId: null,
  contactWebStatusTypeName: null,
  deactivateDate: null,
  passwordExpireDays: null,
  phone: null,
  isDocEmail: null,
  totalContacts: null,
  totalPendingInvite: null,
  totalPendingLogin: null,
  totalActive: null,
  isPasswordSet: null,
  isSecurityQuestionsSet: null,
  isDuoActivated: null,
  isEmailDistribution: null,
  isPaperDistribution: null,
  isManagerCommentary: null,
  isBillingInvoiceNotification: null,
  isTaxDocumentsNotification: null,
};

const useAdminContactStore = create(
  persist(
    (set) => ({
      // ----- STATE -----
      adminContact: initialAdminContact,

      // ----- ACTIONS -----
      setAdminContact: (data) =>
        set(() => ({
          adminContact: { ...initialAdminContact, ...data },
        })),

      resetAdminContact: () =>
        set(() => ({
          adminContact: initialAdminContact,
        })),
    }),
    {
      name: "adminContact-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default useAdminContactStore;